// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"85ebe15d","453":"4071c313"}[chunkId] + ".chunk.js";
};